import React from 'react';
import PageHero from '../components/PageHero';
import CtaBand from '../components/CtaBand';
import SERVICES from '../data/services';

export default function Services() {
  return (
    <>
      <PageHero
        modifier="services"
        kicker="Enterprise Technology Services"
        title="Services"
        desc="Specialized services across SAP BTP, integration modernization, data analytics, ERP/CRM, cloud engineering and AI services."
      />
      <section className="section">
        <div className="container grid grid-3 animate-cards">
          {SERVICES.map((s, i) => (
            <div className="card card--service" key={i}>
              <div className="service-card-top">
                <div className="card-tag">{s.tag}</div>
                <div
                  className={`service-logos ${s.logos.length > 1 ? 'service-logos--dual' : ''} ${s.logos.length > 2 ? 'service-logos--triple' : ''} ${s.title === 'AI, ML & Generative AI' ? 'service-logos--ai' : ''}`}
                  aria-label={`${s.title} partner logos`}
                >
                  {s.logos.map((logo, j) => (
                    <span key={j} className={`service-logo-shell ${logo.shellClass || ''}`}>
                      <img
                        className="service-logo"
                        src={logo.src}
                        alt={logo.alt}
                        loading="lazy"
                      />
                    </span>
                  ))}
                </div>
              </div>
              <div className="icon-circle">{s.icon}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
              <ul>{s.items.map((item, j) => <li key={j}>{item}</li>)}</ul>
            </div>
          ))}
        </div>
      </section>

      <CtaBand
        heading="Need Help Choosing the Right Service?"
        sub="Talk to our team and get a tailored recommendation."
        linkTo="/contact"
        linkLabel="Contact Us"
      />
    </>
  );
}
